import React from 'react';
export default class GoTop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render(){
        const _this = this;
        return (
            <div className="common-gotop">
                <div className="btn-gotop" onClick={ _this.goBack.bind(_this) }>
                    <img src={ require("../../assets/images/back_top.png") }/>
                </div>
            </div>     
        );
    }
    /**
     * 返回上一级页面
     * */ 
    goBack (){
        let scrollToTop = window.setInterval(function() {
            let pos = window.pageYOffset;
            if ( pos > 0 ) {
                window.scrollTo( 0, pos - 20 ); // how far to scroll on each step
            } else {
                window.clearInterval( scrollToTop );
            }
        }, 2);
    }
    
}


